import styles from "./BannerModal.module.scss";

export function CustomBanner({ children, onClose, showCloseButton = true }) {
	return (
		<div className={styles.overlay_banner}>
			<div className={styles.content} onClick={e => e.stopPropagation()}>
				{showCloseButton && (
					<button className={styles.close_button} onClick={onClose}>
						&times;
					</button>
				)}
				{children}
			</div>
		</div>
	);
}
